import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarDatesSelected } from '../../services/date-selection.service';
import {PillChangeEvent} from '../../../../models/pill-change-event.model';
import { PillComponent } from '../../../pill/pill.component';

@Component({
  selector: 'rx-calendar-quick-selection',
  standalone: true,
  imports: [CommonModule, PillComponent],
  templateUrl: './calendar-quick-selection.component.html',
  styleUrls: ['./calendar-quick-selection.component.scss'],
})
export class CalendarQuickSelectionComponent {
  selectedDays: string;

  @Input() quickSelectionOptions: { days: string; label: string; }[] = [];
  @Output() quickSelection: EventEmitter<number> = new EventEmitter<number>();
  @Input() testIdPrefix: string;

  @Input() set selectedDates(selectedDates: CalendarDatesSelected) {
    if (this.selectedDays && !selectedDates.endDate) {
      this.resetSelection();
    }
  }

  @Input() set isOpen(isOpen: boolean) {
    if (isOpen) {
      this.resetSelection();
    }
  }

  @Input() set selectedDateType(selectedDateType: string) {
    this.resetSelection();
  }

  onQuickSelectionChange(pillChangeEvent: PillChangeEvent): void {
    this.selectedDays = pillChangeEvent.id;
    this.quickSelection.emit(Number(pillChangeEvent.id));
  }

  private resetSelection(): void {
    this.selectedDays = undefined;
  }
}
